export default __webpack_public_path__ + "static/media/protect-loved-ones.14db0374.svg";